<div class="container main-layout">
  <div class="right-container">
    <div class="flex-header padd-header">
      <div class="float-left">
        <div class="abio-heading" *ngIf="menuForTrainer"><div class="abro">Manage {{this.config.RolePlay.DisplayText}}</div> </div>
        <div class="abio-heading" *ngIf="!menuForTrainer"><div class="abro">{{this.config.RolePlay.DisplayText}}</div> </div>
      </div>
      <div class="float-right">
        <button *ngIf="menuForTrainer" class="right-button" (click)="doctorprofile()">
          <span>+ Customer Profiles</span>
        </button>
      </div>
    </div>

    <!-- <div class="animation">
      <div class="abio-heading" *ngIf="menuForTrainer"><div class="abro">Manage {{this.config.RolePlay.DisplayText}}</div> </div>
      <div class="abio-heading" *ngIf="!menuForTrainer"><div class="abro">{{this.config.RolePlay.DisplayText}}</div> </div>
    </div>
    <button *ngIf="menuForTrainer" class="right-button" (click)="doctorprofile()">
      <span>+ Doctor Profiles</span>
    </button> -->
    <div class="head-block">
    <!--   <div class="button-div">
        <button [ngClass]="test_version ? 'active-btn1' : 'inactive-btn1'" (click)="score()">
          <span>Score Track</span>
        </button>
        <button [ngClass]="test_version ? 'inactive-btn1' : 'active-btn1'" (click)="practice()">
          <span>Practice Track</span>
        </button>
      </div> -->
      <div class="hb-top">
        <span class="head-text" *ngIf="menuForTrainer"> Explore {{this.config.RolePlay.DisplayText}} </span>
        <span class="head-text" *ngIf="!menuForTrainer"> Assigned {{this.config.RolePlay.DisplayText}}</span>
        <span class="sub-heading">Discover and train with pre-defined role-play scenarios</span>
      </div>
      <div class="search-container">
        <span><img src="../../../assets/images/search-lefticon.png" alt=""></span>
        <input matInput #searchInput placeholder="Search Scenarios..." class="search-box" (input)="applyFilter(searchInput.value)">
        <div class="search-icon"><img src="../../../assets/images/searchabio.png" alt=""></div>
      </div>
      <div *ngIf="showNoCardsMessage">
        No search results found.
      </div>
      
    </div>

    <div class="flex-header padd-header">
      <div class="float-left">&nbsp;</div>
      <div class="float-right">
        <button *ngIf="menuForTrainer" class="right-button1" (click)="createScenario()">
          <span>+ Create Scenario</span>
        </button>
      </div>
    </div>
    
    <div class="container scroll">
      <div class="box-heading" *ngIf="role === 'TRAINEE'">
      {{ completeCount }} of {{ totalCount }} completed
      </div>
      <div class="box-heading" *ngIf="role !== 'TRAINEE'">
        {{totalTrainerCount}} Created
        </div>
      <div class="row">
        <div class="column"  *ngFor="let item of filteredItems.length ? filteredItems : items">
          <div class="card"  *ngIf="!showNoCardsMessage">
            <div class="card-top-div">
              <div class="ctd-1">
                <!-- <span class="card-s1" *ngIf="menuForTrainer" (click)="cardClickHandler(item)">{{ item.doctor_name }}</span> -->
                <span class="card-s2"   [title]="item.scenario_name" (click)="cardClickHandler(item)">{{ item.scenario_name  | truncate:15}} </span>
                <span class="card-s1" *ngIf="!menuForTrainer" (click)="cardClickHandler(item)">{{ item.roleplay_status }}</span>
              </div>
              <div class="ctd-2" *ngIf="menuForTrainer"> <button mat-button [matMenuTriggerFor]="menu" class="dots"><div class="dot-align">...</div></button>
                <mat-menu #menu="matMenu" class="dot-menu">
                  <button class="option" (click)="updateScenario(item.scenario_id)" mat-menu-item>Edit</button>
                  <button (click)=" delete(item.scenario_id)" class="option" mat-menu-item>Delete</button>
                  <button class="option" mat-menu-item
                    (click)="redirectToAssignRoleplay(item.scenario_id)">Assign</button>
                </mat-menu>
              </div>
              <div class="ctd-2" *ngIf="!menuForTrainer">
                <span><img src="../../../assets/images/info-icon.svg" alt=""></span>
                <!-- <button mat-button class="dots-image">
                  
              </button> -->
                <div class="roleplay-tooltip">
                    <span>Objectives of Roleplay</span>
                    <ul *ngIf="item.objectives">
                        <li *ngFor="let item of item.objectives">{{item}}</li>
                    </ul>
                    <ul *ngIf="!item.objectives">
                        <li>NA</li>
                    </ul>
                </div>
            </div>
            </div>
            <div class="header">
              <span class="card-s1" *ngIf="menuForTrainer"  (click)="cardClickHandler(item)">Created on {{ item.created_date }}</span>
              <!-- <span class="card-s2" (click)="cardClickHandler(item)">{{ item.scenario_name }} </span> -->
              <span class="card-s3" *ngIf="item.objectives" (click)="cardClickHandler(item)" title="{{item.objectives[0]}}">{{ (item.objectives) ? item.objectives[0] : "" }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>